import { useState, useEffect } from "react";
import jwtDecode from "jwt-decode";
import { useToken } from "./use-token";

export const useUser = () => {
  const [token] = useToken();

  const getUserInfo = (token) => {
    return jwtDecode(token);
  };

  const [user, setUser] = useState(() => {
    if (!token) return null;
    return getUserInfo(token);
  });

  useEffect(() => {
    if (!token) {
      setUser(null);
    } else {
      setUser(getUserInfo(token));
    }
  }, [token]);

  return user;
};
